import { html } from '/vendor/htm-preact.module.js';

/**
 * How big the text is.
 *
 * The app sizes almost everything in rem, and the wall layouts clamp a vw
 * measure between a rem floor and a rem ceiling. On a high-resolution screen
 * the vw term is large and the CEILING is what you actually get — so raising
 * the root size raises those ceilings and the whole app grows with it. That is
 * why this is a root font-size and not a pile of overrides.
 *
 * Applied in index.html before the first paint, and here when it changes.
 */
const KEY = 'cueforge.textscale';

export const SIZES = [
  { id: 0.9, label: 'Small' },
  { id: 1, label: 'Normal' },
  { id: 1.15, label: 'Large' },
  { id: 1.3, label: 'Larger' },
  { id: 1.5, label: 'Biggest' },
];

export function textScale() {
  try {
    return Number(localStorage.getItem(KEY)) || 1;
  } catch (e) { return 1; }
}

export function setTextScale(scale) {
  document.documentElement.style.fontSize = `${scale * 100}%`;
  try { localStorage.setItem(KEY, String(scale)); } catch (e) { /* fine */ }
}

/** The picker. Shows its effect in its own labels, which is the whole point. */
export function TextSize({ onChanged }) {
  const now = textScale();
  return html`
    <div class="stack" data-testid="text-size">
      <label>Text size</label>
      <div class="seg">
        ${SIZES.map((s) => html`
          <button key=${s.id} aria-pressed=${Math.abs(now - s.id) < 0.001}
                  data-testid=${`textsize-${String(s.id).replace('.', '_')}`}
                  onClick=${() => { setTextScale(s.id); onChanged(); }}>
            ${s.label}
          </button>`)}
      </div>
      <p class="sub">
        Everything grows together — a tablet across the room usually wants
        Large or more.
      </p>
    </div>`;
}
